const initialState = {
    allEntries: [],
};

export default (state = initialState, action = {}) => {
    switch (action.type) {
        case 'entries/SET_ENTRIES':
            return {
                ...state,
                allEntries: action.payload
            }
        default:
            return state;
    }
};
